const DEV_PROXY_PREFIX = '/__proxy';

const withoutTrailingSlash = (url: string): string => url.replace(/\/$/, '');

/**
 * Routes a url on the tenant's backend through the dev server proxy, with scheme and
 * host moved into the path, e.g. `https://kunde.cmicloud.ch/api` ->
 * `/__proxy/https/kunde.cmicloud.ch/api`. The request is then same origin and no
 * longer needs CORS headers; `proxy.conf.mjs` forwards it to the host named in the path.
 *
 * Urls not starting with `backend`, and calls without one, are left untouched. See
 * the "Dev proxy" section in the README.
 */
export function toDevProxyUrl(url: string, backend: string | undefined): string {
  const match = /^(https?):\/\/([^/?#]+)(.*)$/.exec(url);

  if (!backend || !match || !url.startsWith(withoutTrailingSlash(backend))) {
    return url;
  }

  const [, scheme, host, rest] = match;

  return `${DEV_PROXY_PREFIX}/${scheme}/${host}${rest}`;
}
